import * as React from "react";
import { Interactions } from "../core/providers/interactions.provider.tsx";
import {
  AdvancedGrid,
  type GridColumn,
} from "../shared/advanced-grid/advanced-grid.component.tsx";

interface Contact {
  id: string;
  name: string;
  phone: string;
  source: string;
  age: number;
  when: string;
}

const INITIAL: Contact[] = [
  {
    id: "a",
    name: "Léa Moreau",
    phone: "06 12 34 56 78",
    source: "Doctolib",
    age: 34,
    when: "il y a 12min",
  },
  {
    id: "b",
    name: "Hugo Martin",
    phone: "07 98 76 54 32",
    source: "Téléphone",
    age: 45,
    when: "il y a 1h",
  },
];

export function FirstContactGridWidget({ panelId }: { panelId: string }) {
  const [items, setItems] = React.useState<Contact[]>(INITIAL);
  const toast = Interactions.useToast();
  const dialog = Interactions.useDialog();

  const handleCall = (p: Contact) => {
    toast.push({
      type: "info",
      title: `Appel de ${p.name}…`,
      message: p.phone,
    });
    setTimeout(() => {
      setItems((prev) => prev.filter((i) => i.id !== p.id));
      toast.push({ type: "success", title: "Contact traité" });
    }, 800);
  };
  const handleSchedule = (p: Contact) => {
    dialog.openNewRdv(p.name);
    setItems((prev) => prev.filter((i) => i.id !== p.id));
  };

  const columns: GridColumn<Contact>[] = [
    {
      id: "name",
      label: "Nom",
      accessor: (r) => r.name,
      sortable: true,
      width: "180px",
      render: (r) => <span className="font-semibold">{r.name}</span>,
    },
    {
      id: "source",
      label: "Source",
      accessor: (r) => r.source,
      sortable: true,
      width: "110px",
      render: (r) => (
        <span className="inline-block rounded border border-sf-border bg-white px-1.5 py-px text-[10.5px] font-semibold text-sf-text-muted">
          {r.source}
        </span>
      ),
    },
    {
      id: "when",
      label: "Quand",
      accessor: (r) => r.when,
      sortable: false,
      width: "110px",
      render: (r) => <span className="text-sf-text-muted">{r.when}</span>,
    },
    {
      id: "phone",
      label: "Téléphone",
      accessor: (r) => r.phone,
      sortable: false,
      width: "140px",
      render: (r) => <span className="tabular-nums">{r.phone}</span>,
    },
    {
      id: "age",
      label: "Âge",
      accessor: (r) => r.age,
      sortable: true,
      width: "70px",
      align: "right",
      render: (r) => <span className="tabular-nums">{r.age} ans</span>,
    },
    {
      id: "actions",
      label: "Actions",
      accessor: () => "",
      sortable: false,
      width: "180px",
      render: (r) => (
        <div className="flex gap-1">
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              handleCall(r);
            }}
            className="rounded border border-sf-primary bg-sf-primary px-2 py-0.5 text-[11px] font-semibold text-white hover:bg-sf-primary-hover"
          >
            Rappeler
          </button>
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              handleSchedule(r);
            }}
            className="rounded border border-sf-border bg-white px-2 py-0.5 text-[11px] font-semibold text-sf-text hover:bg-sf-surface-alt"
          >
            RDV
          </button>
        </div>
      ),
    },
  ];

  return (
    <AdvancedGrid<Contact>
      instanceId={panelId}
      columns={columns}
      rows={items}
      rowKey={(r) => r.id}
      emptyMessage="Tous les contacts ont été traités ✨"
    />
  );
}
